import {ISpeechSynthesisVoiceCollection, WebSpeechUtils} from "../utils/WebSpeechUtils";
import {WebSpeechTtsSynthesizer} from "@colibrio/colibrio-reader-framework/colibrio-readingsystem-engine";
import * as colibrioReadingSystemBase from "@colibrio/colibrio-reader-framework/colibrio-readingsystem-base";
import {IVanillaTtsServiceProvider} from "./VanillaReaderModel";

export class VanillaReaderWebSpeechTtsSynthesizer extends WebSpeechTtsSynthesizer implements IVanillaTtsServiceProvider {
    private _activeVoice: SpeechSynthesisVoice | undefined;
    private _ttsVoiceCollection: ISpeechSynthesisVoiceCollection | undefined;

    constructor(onConfigureUtterance?: ((utterance: SpeechSynthesisUtterance, utteranceAdditionalData?: colibrioReadingSystemBase.ITtsUtteranceData | undefined) => void) | undefined) {
        super(onConfigureUtterance);
    }

    get supportsWordBoundaries(): boolean {
        return true;
    }

    setActiveVoice(voice: SpeechSynthesisVoice): void {
        const voiceName = voice.name;
        this._activeVoice = this._ttsVoiceCollection?.allVoices.find(voice => voice.name === voiceName);
    }

    getActiveVoice(): SpeechSynthesisVoice | undefined {
        return this._activeVoice;
    }

    async fetchVoices(): Promise<ISpeechSynthesisVoiceCollection | undefined> {

        if(this._ttsVoiceCollection) {
            return Promise.resolve(this._ttsVoiceCollection);
        }

        this._ttsVoiceCollection = await WebSpeechUtils.fetchTtsVoices();
        return this._ttsVoiceCollection;
    }
}
